var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackToTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4 0h36a4 4 0 0 1 4 4v36a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4Z",
    transform: "translate(1 1)",
    style: {
      stroke: "#484848",
      fill: "#e8f5f1",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(10 11)",
    style: {
      fill: "none",
      strokeWidth: 4,
      stroke: "#484848"
    },
    d: "M0 0h26.568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4296.221 1062.968 7.513-7.431 7.22 7.431",
    transform: "translate(-4280.423 -1037.316)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none",
      strokeWidth: 4,
      stroke: "#484848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4334 1074.1v-16.871",
    transform: "translate(-4310.632 -1039.012)",
    style: {
      strokeLinecap: "round",
      fill: "none",
      strokeWidth: 4,
      stroke: "#484848"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTop);
export default __webpack_public_path__ + "static/media/back-to-top.77fd37c8770883f910db75a762c2a78b.svg";
export { ForwardRef as ReactComponent };